import { atom } from "../../common/miscellaneous/atom";
import { DataTestids } from "../../common/miscellaneous/DataTestids";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export type OrderErrorEvent = DataTestids | undefined;

export const orderErrorEventAtom = atom<OrderErrorEvent>({
  key: RecoilKeys.OrderErrorEvent,
  default: undefined,
});
